import { USER_PROFILE, USER_PROFILE_GET } from '../redux/serverEndpoints';
import { MapBase } from './MapBase';
export class UserProfile extends MapBase {
    constructor() {
        super();
        this.user_guid = null;
        this.birthdate = null;
        this.timezone = null;
        this.hobbies = null;
        this.extra_curricular = null;
        this.leadership_roles = null;
        this.other_info = null;
        this.date_modified = null;
        this.date_created = null;
        this.profile_photo_url = null;
        this.job_history = [];
        this.education = [];
        this.mapClassName = "user-profile";
        this._apiController = "user-profile";
    }
    load(guid, onSuccess, onFailure = null) {
        this.standardLoad(this, guid, USER_PROFILE, onSuccess, onFailure);
    }
    loadByUser(user_guid, onSuccess, onFailure = null) {
        this.standardLoad(this, user_guid, USER_PROFILE_GET(user_guid), onSuccess, onFailure);
    }
    archive(onSuccess, onFailure = null) {
        this.standardArchive(this, onSuccess, onFailure);
    }
}
//# sourceMappingURL=UserProfile.js.map